import React from "react";

import {  Card,  Col
  } from "reactstrap";
import CardBody from "reactstrap/lib/CardBody";
import { StandardList } from './StandardList';


export const ActiveSessions = ( { sessions } ) =>  {
    let cols = [
        { id: 'name', title: 'Nombre', type:"STRING"}, 
        { id: 'last_name', title: 'Apellido', type:"STRING"},
        { id: 'login_id', title: 'Usuario', type:"STRING" },
        { id: 'image', title: 'imagen', type:"IMG", size:"50" },
        { id: 'total', title: 'QTY', type:"STRING", size:"50" },
        { id: 'max_due_date', title: 'Valida hasta', type:"DATETIME" } 
       ] ;

    return (
        <>
        <Col > 
            <Card>
                <CardBody>

                <StandardList
                    title="Sesiones activas"
                    rows={sessions}
                    cols={cols}
                    actions={[]}
                    />
                </CardBody>

            </Card>
        </Col>
        </>
    )
    }
